<div class="weather-logging-page">
  <div class="page-header">
    <div class="header-left">
      <button class="back-btn" (click)="goBack()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h1 class="section-title">{{ 'ProcessedDataProtocol' | translate }}</h1>
    </div>
  </div>

  <div class="page-content">
    <div class="table-section">
      <ng-template #annotationTemplate let-row="$implicit">
        <span class="annotation-cell" [pTooltip]="row.annotation" tooltipPosition="top">{{ getAnnotationDisplay(row) }}</span>
      </ng-template>
      <ng-template #actionTemplate let-row="$implicit">
        <div class="action-buttons">
          <button
            pButton
            type="button"
            class="p-button-text p-button-sm p-button-rounded action-btn-icon"
            [pTooltip]="'Edit' | translate"
            tooltipPosition="top"
            (click)="openEditModal(row); $event.stopPropagation()">
            <img src="assets/icons/main/light/ico-btn-edit.svg" alt="Edit" class="action-icon action-icon-edit" [style.pointer-events]="'none'">
          </button>
          <button
            pButton
            type="button"
            class="p-button-text p-button-sm p-button-rounded action-btn-icon"
            [pTooltip]="'Download TIF' | translate"
            tooltipPosition="top"
            [disabled]="isDownloading(row.id)"
            (click)="downloadTif(row); $event.stopPropagation()">
            <span *ngIf="!isDownloading(row.id)">
              <img src="assets/icons/main/light/ico-download.svg" alt="Download" class="action-icon" [style.pointer-events]="'none'">
            </span>
            <span *ngIf="isDownloading(row.id)" class="p-button-icon pi pi-spin pi-spinner" style="margin: 0"></span>
          </button>
        </div>
      </ng-template>
      <app-dynamic-data-table
        [(loading)]="loading"
        [toggleFilter]="toggleFilter"
        [service]="service"
        [getAllMethod]="'getByQueryPost'"
        [getTotalMethod]="'getTotalCountPost'"
        [filter]="filtersParams"
        [columns]="tableColumns"
        [defaultParams]="defaultParams"
        [storageKey]="'weather_data_processing'"
        [methodWithParams]="true"
        [config]="tableConfig">
      </app-dynamic-data-table>

  <p-dialog [resizable]="false" [draggable]="false"
    [header]="'ProcessedDataProtocol' | translate"
    [(visible)]="showEditModal"
    [modal]="true"
    [style]="{ width: '90vw', maxWidth: '560px', borderRadius: '16px' }"
    [closeOnEscape]="true"
    [dismissableMask]="true"
    (onHide)="closeEditModal()"
    styleClass="weather-layer-edit-modal">
    <ng-container *ngIf="editLayer">
      <div class="modal-fields">
        <div class="modal-field modal-field-half">
          <label>{{ 'Data source' | translate }}</label>
          <span class="modal-value">{{ editLayer.dataSource | translate }}</span>
        </div>
        <div class="modal-field modal-field-half">
          <label>{{ 'Data type' | translate }}</label>
          <span class="modal-value">{{ editLayer.layerType | translate }}</span>
        </div>
        <div class="modal-field modal-field-full">
          <label>{{ 'Indicator' | translate }}</label>
          <span class="modal-value">{{ editLayer.indicatorName | translate }}</span>
        </div>
        <div class="modal-field modal-field-half">
          <label>{{ 'Layer date' | translate }}</label>
          <span class="modal-value">{{ editLayer.layerDate ? formatDate(editLayer.layerDate) : '—' }}</span>
        </div>
        <div class="modal-field modal-field-half">
          <label>{{ 'Created at' | translate }}</label>
          <span class="modal-value">{{ formatDate(editLayer.createAt) }}</span>
        </div>
        <div class="modal-field modal-field-half">
          <label>{{ 'File size (KB)' | translate }}</label>
          <span class="modal-value">{{ editLayer.fileSizeKb != null ? (editLayer.fileSizeKb + ' KB') : '—' }}</span>
        </div>
        <div class="modal-field modal-field-annotation modal-field-full">
          <label>{{ 'Annotation' | translate }}</label>
          <textarea
            pInputTextarea
            [(ngModel)]="editAnnotation"
            [rows]="4"
            class="annotation-textarea"
            [placeholder]="'Annotation' | translate"></textarea>
        </div>
      </div>
    </ng-container>
    <ng-template pTemplate="footer">
      <div class="modal-footer-actions modal-footer-grid">
        <app-button type="button" variant="primary" (onClick)="saveEditAnnotation()">
          {{ 'Save' | translate }}
        </app-button>
        <app-button
          type="button"
          variant="primary"
          [loading]="downloadingModal"
          [disabled]="downloadingModal"
          (onClick)="editLayer && downloadTif(editLayer, 'modal')">
          {{ 'Download TIF' | translate }}
        </app-button>
      </div>
    </ng-template>
  </p-dialog>
  <p-toast></p-toast>
    </div>
    <div class="filters-sidebar">
      <div class="filters-panel__header">
        <h3>{{ 'Filters' | translate }}</h3>
      </div>
      <div class="sidebar-content">
        <div class="filter-group">
          <label>{{ 'Data source' | translate }}</label>
          <app-dropdown
            [options]="dataSourceOptions"
            [(ngModel)]="tempDataSource"
            [placeholder]="'Data source' | translate"
            optionLabel="label"
            optionValue="value">
          </app-dropdown>
        </div>

        <div class="filter-group">
          <label>{{ 'Data type' | translate }}</label>
          <app-dropdown
            [options]="typeOptions"
            [(ngModel)]="tempType"
            [placeholder]="'Data type' | translate"
            optionLabel="label"
            optionValue="value">
          </app-dropdown>
        </div>

        <div class="filter-group">
          <label>{{ 'Indicator' | translate }}</label>
          <app-dropdown
            [options]="indicatorOptions"
            [(ngModel)]="tempIndicator"
            [placeholder]="'Indicator' | translate"
            optionLabel="label"
            optionValue="value">
          </app-dropdown>
        </div>

        <div class="filter-group">
          <label>{{ 'Created at' | translate }}</label>
          <app-date-picker
            [(ngModel)]="tempCreateAtPeriod"
            [selectionMode]="'range'"
            [placeholder]="'Date Range' | translate"
            [showIcon]="true"
            [showClear]="true"
            [dateFormat]="'dd.mm.yy'">
          </app-date-picker>
        </div>

        <div class="filter-group">
          <label>{{ 'Layer date' | translate }}</label>
          <app-date-picker
            [(ngModel)]="tempLayerDatePeriod"
            [selectionMode]="'range'"
            [placeholder]="'Date Range' | translate"
            [showIcon]="true"
            [showClear]="true"
            [dateFormat]="'dd.mm.yy'">
          </app-date-picker>
        </div>

        <div class="filter-actions">
          <app-button [variant]="'primary'" [fullWidth]="true" (onClick)="applyFilters()">
            {{ 'Apply' | translate}}
          </app-button>
          <app-button [variant]="'secondary'" [fullWidth]="true" (onClick)="resetFilters()">
            {{ 'Reset filter' | translate}}
          </app-button>
          <app-button [variant]="'secondary'" [fullWidth]="true" (onClick)="exportToCsv()">
            {{ 'Export to CSV' | translate }}
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>
